import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { Equipment } from '@bytel/bytel-sales';
import { CommercialProposal, FUNDING_ENUM, FundingMethod } from '@bytel/checkout';

import { ModalService } from '@base/common/services/modal.service';

import { ModalComponent } from '@shared/modal/modal.component';

import { FundingInfosPhoneLineComponent } from './funding-infos-phone-line/funding-infos-phone-line.component';

@Component({
    selector: 'checkout-funding-infos-phone',
    templateUrl: './funding-infos-phone.component.html',
    styleUrl: 'funding-infos-phone.component.scss',
    standalone: true,
    imports: [FundingInfosPhoneLineComponent, ModalComponent],
})
export class FundingInfosPhoneComponent extends ModalComponent {
    @Input() equipment: Equipment;
    @Input() funding: FundingMethod;
    @Input() commercialProposal: CommercialProposal;
    @Input() fundingMessage: string;

    public modalRef: ModalService;
    public fundingLines: { lineTitle: string; value: string; isBold?: boolean }[] = [];

    ngOnInit(): void {
        const currencyPipe = new CurrencyPipe('fr-FR', 'EUR');
        this.fundingLines = [
            {
                lineTitle: 'Paiement',
                value: `${currencyPipe.transform(this.commercialProposal.monthlyAmount)} x ${this.commercialProposal.nbLoan}`,
                isBold: true,
            },
            { lineTitle: 'Montant financé', value: currencyPipe.transform(this.commercialProposal.amountToFund) },
            { lineTitle: 'Intérêts', value: currencyPipe.transform(this.commercialProposal.interestAmount) },
            {
                lineTitle: 'Montant total dû',
                value: currencyPipe.transform(this.commercialProposal.fundingFinalCost),
                isBold: true,
            },
            {
                lineTitle: 'TAEG fixe',
                value: `${this.commercialProposal.tAEG.toString().replace('.', ',')}%`,
                isBold: true,
            },
        ];

        if (this.commercialProposal?.fixedRate >= 0) {
            this.fundingLines.push({
                lineTitle: 'Taux débiteur fixe',
                value: `${this.commercialProposal.fixedRate.toString().replace('.', ',')}%`,
            });
        }
    }

    public getModalTitle(): string {
        return `Paiement en ${this.funding.type === FUNDING_ENUM.COFIDIS ? this.commercialProposal.nbLoan + 1 : this.commercialProposal.nbLoan} fois ${this.commercialProposal.interestAmount > 0 ? 'avec' : 'sans'} frais`;
    }

    public getSvg(): string {
        if (this.funding.type === FUNDING_ENUM.SWAPPY) {
            return `assets/logo-younited.svg`;
        }
        return `assets/logo-${this.funding.type.toLowerCase()}.svg`;
    }

    public getAltText(): string {
        if (this.funding.type === FUNDING_ENUM.SWAPPY) {
            return 'logo younited';
        }
        return `logo ${this.funding.type}`;
    }

    public close(): void {
        this.modalRef.close();
    }
}
